<template>
    <v-container fluid fill-height>
        <v-card  outlined width="100%" class="fill-height">
            <v-card-text class="pa-5">
                <v-row>
                    <v-col cols=6 md=6 lg=6 sm=6>
                        <v-chip label color="amber"> <v-icon left>mdi-account-multiple</v-icon>Party Manager</v-chip>
                    </v-col>
                    <v-col cols=6 md=6 lg=6 sm=6 style="postion:relative">
                        <v-speed-dial v-model="fab" direction="left" :open-on-hover="false" 
                        transition="slide-y-reverse-transition" class="Speed-button-Setting">
                            <template v-slot:activator>
                                <v-btn v-model="fab" color="amber" fab class="elevation-0">
                                <v-icon v-if="fab">mdi-close</v-icon>
                                <v-icon v-else>mdi-account-multiple</v-icon>
                                </v-btn>
                            </template>
                            <v-btn fab dark small color="indigo" @click="CreateBox = true"><v-icon>mdi-plus</v-icon></v-btn>
                            <v-btn fab dark small color="red"><v-icon>mdi-delete</v-icon></v-btn>
                        </v-speed-dial>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols=12 md=12 lg=12 sm=12>
                        <v-card flat>
                            <v-card-title>
                                <v-spacer></v-spacer>
                                <v-text-field v-model="search" outlined
                                color="amber" append-icon="mdi-magnify" dense
                                 label="Search" hide-details></v-text-field>
                            </v-card-title>
                            <v-data-table :headers="headers" :items="records" :search="search">
                                <template v-slot:item.action="{ item }">
                                    <v-btn color="amber" fab small class="elevation-0" @click="EditBox = true; partyId=item.id"><v-icon color="black">mdi-pencil</v-icon></v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row> 
            </v-card-text>           
        </v-card>
        <v-dialog v-model="CreateBox" transition="dialog-bottom-transition" persistent max-width="700">
            <Party :edit="false" @Response="action($event)" @Close="CreateBox = false"></Party>
        </v-dialog>
        <v-dialog v-model="EditBox" transition="dialog-bottom-transition" persistent max-width="700">
            <Party :edit="true" :id='partyId' @Response="action($event)" @Close="EditBox = false"></Party>
        </v-dialog>
        <v-snackbar v-model="notificationBar" top center :color="notificationColor" multi-line> {{ notificationText }}
            <v-btn color="amber" text @click="notificationBar = false"> Close </v-btn>
        </v-snackbar>
    </v-container>
</template>
<script>
import Party from '../../components/customer/parties/index'
import { SERVER_API } from '../../API';
export default {
    components:{Party},
    mounted(){
        this.fetchall();
    },
    data(){
        return{
            partyId:'',
            EditBox:false,
            CreateBox:false,
            search:'',
            fab:false,
            headers:[
                { text: 'Party Name', value: 'name' },
                { text: 'Location', value: 'location' },
                { text: 'Action', value: 'action' },
            ],
            records:[],

            // Notification Setting
            notificationColor: 'black',
            notificationBar: false,
            notificationText:''
        }
    },
    methods:{
        async fetchall(){
            const response =  await this.$http.get(SERVER_API+'/broker/party/records');
            this.records = response.data.data;
        },
        action(e){
            if(e.action == true){
                this.notificationColor = 'black';
                this.notificationBar = true;
                this.notificationText = e.message;
                this.fetchall();
                this.CreateBox = false;
                this.EditBox = false;
            }else{
                this.notificationColor = 'red';
                this.notificationBar = true;
                this.notificationText = e.message;
                //console.log(e);
            }
        }
    }

}
</script>

<style>
.Speed-button-Setting{
    position:absolute;
    right:30px;
}
</style>